import React, { useEffect } from 'react';
import {
  Outlet,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { useAuthenticator } from '@aws-amplify/ui-react';

// OAuth callback landed but Amplify hasn't finished the token exchange, so auth state isn't settled yet.
const isOAuthCallbackInProgress = (search: string) => {
  const params = new URLSearchParams(search);
  return params.has('code') || params.has('error');
};

export default function ProtectedRoute() {
  const { user } = useAppSelector(state => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  const { route } = useAuthenticator((context) => [context.route]);

  const isAuthenticated = !!user && (route === 'authenticated' || route === 'idle');

  useEffect(() => {
    if (isAuthenticated) return;
    if (isOAuthCallbackInProgress(location.search)) return;

    const redirectTo = `${location.pathname}${location.search}`;

    navigate(`/?redirect=${encodeURIComponent(redirectTo)}`, {
      replace: true,
    });
  }, [user, route, location.pathname, location.search, navigate, isAuthenticated]);

  // Don't mount protected children (or their data fetches) until auth resolves.
  if (!isAuthenticated) return null;

  return <Outlet />;
}
